import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Link,
} from '@react-pdf/renderer'
import { BetterIdAsset } from 'common/types'
import pos1 from 'assets/icons/positions/pos-1.png'
import pos2 from 'assets/icons/positions/pos-2.png'
import pos3 from 'assets/icons/positions/pos-3.png'
import pos4 from 'assets/icons/positions/pos-4.png'
import pos5 from 'assets/icons/positions/pos-5.png'
import pos6 from 'assets/icons/positions/pos-6.png'
import pos7 from 'assets/icons/positions/pos-7.png'
import pos8 from 'assets/icons/positions/pos-8.png'
import pos9 from 'assets/icons/positions/pos-9.png'
import pos10 from 'assets/icons/positions/pos-10.png'
import pos11 from 'assets/icons/positions/pos-11.png'
import pos12 from 'assets/icons/positions/pos-12.png'

// Define positions array with images
const positions = [
  { name: 'Supine', image: pos1 },
  { name: 'Trendelenburg', image: pos2 },
  { name: 'Reverse Trendelenburg', image: pos3 },
  { name: 'Fracture Table', image: pos4 },
  { name: 'Lithotomy', image: pos5 },
  { name: 'Prone', image: pos6 },
  { name: 'Jackknife', image: pos7 },
  { name: "Fowler's", image: pos8 },
  { name: 'Knee-Chest', image: pos9 },
  { name: 'Kidney', image: pos10 },
  { name: 'Lateral', image: pos11 },
  { name: 'Wilson Frame', image: pos12 },
]

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: 'rgb(240, 240, 240)',
    padding: 15,
    paddingBottom: 60,
  },
  header: {
    marginBottom: 20,
    borderBottom: '1 solid rgb(224, 224, 224)',
    paddingBottom: 10,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  headerTitle: {
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    fontWeight: 'bold',
  },
  headerCaseWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerCaseLabel: {
    fontSize: 10,
    color: 'rgb(102, 102, 102)',
  },
  headerCaseValue: {
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    fontWeight: 'bold',
  },
  section: {
    marginBottom: 12,
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: 4,
    padding: 0,
    overflow: 'hidden',
  },
  sectionHeader: {
    backgroundColor: 'rgb(223, 217, 252)',
    padding: 8,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  sectionContent: {
    padding: 4,
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: 'rgb(51, 51, 51)',
    paddingBottom: 2,
  },
  subsectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: 'rgb(68, 68, 68)',
    marginTop: 5,
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 2,
  },
  label: {
    width: '35%',
    fontSize: 10,
    color: 'rgb(102, 102, 102)',
    paddingRight: 6,
  },
  value: {
    width: '70%',
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
  },
  valueLong: {
    width: '70%',
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    lineHeight: 1.3,
  },
  valueLonger: {
    width: '70%',
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    lineHeight: 1.2,
  },
  divider: {
    marginVertical: 15,
  },
  footer: {
    position: 'absolute',
    bottom: 15,
    right: 30,
    textDecoration: 'none',
  },
  poweredByTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  poweredByText: {
    color: 'rgb(80, 53, 237)',
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: 5,
    textDecoration: 'none',
  },
  generatedDate: {
    fontSize: 10,
    color: 'rgb(102, 102, 102)',
    textAlign: 'center',
    marginTop: 5,
  },
  checkboxGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    marginVertical: 5,
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
  },
  checkboxLabel: {
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    marginLeft: 5,
  },
  notes: {
    marginTop: 6,
    padding: 6,
    backgroundColor: 'rgb(248, 249, 250)',
    borderRadius: 4,
  },
  notesText: {
    fontSize: 10,
    color: 'rgb(102, 102, 102)',
    lineHeight: 1.3,
  },
  table: {
    backgroundColor: 'rgb(245, 245, 245)',
    marginBottom: 0,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: 'rgb(224, 224, 224)',
    minHeight: 20,
    alignItems: 'flex-start',
    paddingVertical: 4,
  },
  headerRow: {
    flexDirection: 'row',
    backgroundColor: 'rgb(224, 224, 224)',
    padding: 2,
  },
  rowEven: {
    backgroundColor: 'rgb(245, 245, 245)',
    padding: 2,
  },
  rowOdd: {
    backgroundColor: 'rgb(255, 255, 255)',
    padding: 2,
  },
  tableCell: {
    fontSize: 10,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginRight: 2,
  },
  tableCellDescription: {
    flex: 1,
    paddingRight: 4,
  },
  tableCellQuantity: {
    width: 28,
    textAlign: 'center',
  },
  headerCard: {
    backgroundColor: 'rgb(80, 53, 237)',
    padding: 8,
    borderRadius: 4,
    marginBottom: 12,
  },
  headerCardText: {
    color: 'rgb(255, 255, 255)',
    fontSize: 10,
    fontWeight: 'bold',
  },
  positionSection: {
    marginBottom: 12,
    backgroundColor: 'rgb(248, 249, 250)',
    borderRadius: 4,
    padding: 8,
    alignItems: 'center',
  },
  positionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: 'rgb(51, 51, 51)',
    marginBottom: 8,
    textAlign: 'center',
  },
  positionImage: {
    width: 80,
    height: 80,
    marginBottom: 8,
  },
  equipmentGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 3,
    marginVertical: 2,
  },
  equipmentItem: {
    width: '23%',
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    padding: 2,
  },
  notesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 3,
    marginVertical: 2,
  },
  noteItem: {
    width: '30%',
    fontSize: 10,
    color: 'rgb(102, 102, 102)',
    padding: 2,
  },
  surgeonGrid3Col: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 2,
  },
  surgeonGridCol: {
    flex: 1,
    paddingRight: 2,
    justifyContent: 'flex-start',
  },
  surgeonGridPic: {
    width: 60,
    alignItems: 'center',
    justifyContent: 'center',
  },
  surgeonImage: {
    width: 50,
    height: 50,
    objectFit: 'cover',
    borderRadius: 4,
  },
  grid3ColContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 2,
    justifyContent: 'center',
    maxWidth: '100%',
  },
  grid3ColItem: {
    fontSize: 10,
    color: 'rgb(51, 51, 51)',
    backgroundColor: 'rgb(245, 245, 255)',
    borderRadius: 4,
    padding: 4,
    marginBottom: 2,
    flexBasis: '48%',
    flexGrow: 0,
    flexShrink: 0,
    textAlign: 'center',
    maxWidth: '48%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})

interface PreferenceCardsPDFProps {
  preferenceCards: any[]
  products?: BetterIdAsset[]
  showSurgeryInfo?: boolean
  surgeryInfo?: {
    dateTime: string
    surgeonLastName: string
    surgeonFirstName: string
    description: string
    patientMRN: string
    patientLastName: string
    patientFirstName: string
  }
  showPascPreferenceCardFeatures?: boolean
}

const PreferenceCardsPDF = ({
  preferenceCards,
  products = [],
  showSurgeryInfo = false,
  surgeryInfo,
  showPascPreferenceCardFeatures = false,
}: PreferenceCardsPDFProps) => {
  const rootPath = window.location.origin

  // Special settings to be grouped under their parent device (outer scope)
  const specialSettingsMap: Record<string, { parent: string; label: string }> =
    {
      'Laser notes': { parent: 'Laser', label: 'Notes' },
      'Cell Saver notes': { parent: 'Cell Saver', label: 'Notes' },
      'Drill Type': { parent: 'Drill', label: 'Type' },
      'Robot Settings': { parent: 'Robot', label: 'Settings' },
    }

  const Footer = () => (
    <View style={styles.footer} fixed>
      <Link src="https://www.medgeo.com/">
        <View style={styles.poweredByTextContainer}>
          <Text style={styles.poweredByText}>Powered by</Text>
          <Image src={`${rootPath}/medgeoLogo.png`} style={{ height: 18 }} />
        </View>
      </Link>
    </View>
  )

  return (
    <Document>
      {/* Preference Cards */}
      {preferenceCards.map((card, index) => (
        <Page key={card.id || index} size="A4" style={styles.page}>
          <View style={styles.headerContainer}>
            <View>
              <Text style={[styles.headerTitle, { marginTop: 4 }]}>
                {showSurgeryInfo && card.surgeryInfo
                  ? card.surgeryInfo.description
                  : card?.name?.length > 60
                  ? card.name.substring(0, 60) + '...'
                  : card?.name || 'Preference Card Details'}
              </Text>
              {showSurgeryInfo && card.surgeryInfo && (
                <Text style={[styles.headerTitle, { marginTop: 4 }]}>
                  {card?.name?.length > 60
                    ? card.name.substring(0, 60) + '...'
                    : card?.name || 'Preference Card Details'}
                </Text>
              )}
            </View>
            <View style={styles.headerCaseWrapper}>
              <Text style={styles.generatedDate}>
                Generated on: {new Date().toLocaleDateString()}
              </Text>
            </View>
          </View>

          {/* Only show preference card sections if we have a valid card */}
          {card?.id && (
            <>
              {/* Surgery Information */}
              {showSurgeryInfo && card.surgeryInfo && (
                <View style={styles.section}>
                  <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Surgery Information</Text>
                  </View>
                  <View style={styles.sectionContent}>
                    <View style={styles.surgeonGrid3Col}>
                      <View style={styles.surgeonGridCol}>
                        <View style={styles.row}>
                          <Text style={styles.label}>Date:</Text>
                          <Text style={styles.value}>
                            {new Date(
                              card.surgeryInfo.dateTime
                            ).toLocaleDateString()}
                          </Text>
                        </View>
                        <View style={styles.row}>
                          <Text style={styles.label}>Patient:</Text>
                          <Text style={styles.value}>
                            {`${card.surgeryInfo.patientFirstName} ${card.surgeryInfo.patientLastName} (MRN: ${card.surgeryInfo.patientMRN})`}
                          </Text>
                        </View>
                        <View style={styles.row}>
                          <Text style={styles.label}>Surgeon:</Text>
                          <Text style={styles.value}>
                            {`${card.surgeryInfo.surgeonFirstName} ${card.surgeryInfo.surgeonLastName}`}
                          </Text>
                        </View>
                        <View style={styles.row}>
                          <Text style={styles.label}>Procedure:</Text>
                          <Text style={styles.value}>
                            {card.surgeryInfo.description}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              )}

              {/* Surgeon Information */}
              {(card.surgeon?.firstName ||
                card.surgeon?.lastName ||
                card.procedure_type ||
                card.card_details?.surgeonInformation?.dominantHand?.name ||
                card.card_details?.surgeonInformation?.gloveSize ||
                card.card_details?.surgeonInformation?.gloveType ||
                card.card_details?.surgeonInformation?.picture ||
                card.card_details?.surgeonInformation?.notes?.length > 0) && (
                <View style={styles.section}>
                  <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Surgeon Information</Text>
                  </View>
                  <View style={styles.sectionContent}>
                    <View style={styles.surgeonGrid3Col}>
                      {/* Column 1 */}
                      {(card.surgeon?.firstName ||
                        card.surgeon?.lastName ||
                        card.procedure_type) && (
                        <View style={styles.surgeonGridCol}>
                          {card.surgeon?.firstName &&
                            card.surgeon?.lastName && (
                              <View style={styles.row}>
                                <Text style={styles.label}>Surgeon Name:</Text>
                                <Text style={styles.value}>
                                  {`${card.surgeon.firstName} ${card.surgeon.lastName}`}
                                </Text>
                              </View>
                            )}
                          {card.procedure_type && (
                            <View style={styles.row}>
                              <Text style={styles.label}>Procedure Name:</Text>
                              <Text style={styles.value}>
                                {card.procedure_type}
                              </Text>
                            </View>
                          )}
                        </View>
                      )}
                      {/* Column 2 */}
                      {(card.card_details?.surgeonInformation?.dominantHand
                        ?.name ||
                        card.card_details?.surgeonInformation?.gloveSize ||
                        card.card_details?.surgeonInformation?.gloveType) && (
                        <View style={styles.surgeonGridCol}>
                          {card.card_details?.surgeonInformation?.dominantHand
                            ?.name && (
                            <View style={styles.row}>
                              <Text style={styles.label}>Dominant Hand:</Text>
                              <Text style={styles.value}>
                                {
                                  card.card_details.surgeonInformation
                                    .dominantHand.name
                                }
                              </Text>
                            </View>
                          )}
                          {card.card_details?.surgeonInformation?.gloveSize && (
                            <View style={styles.row}>
                              <Text style={styles.label}>Glove Size:</Text>
                              <Text style={styles.value}>
                                {card.card_details.surgeonInformation.gloveSize}
                              </Text>
                            </View>
                          )}
                          {card.card_details?.surgeonInformation?.gloveType && (
                            <View style={styles.row}>
                              <Text style={styles.label}>Glove Type:</Text>
                              <Text style={styles.value}>
                                {card.card_details.surgeonInformation.gloveType}
                              </Text>
                            </View>
                          )}
                        </View>
                      )}
                      {/* Column 3: Picture */}
                      {card.card_details?.surgeonInformation?.picture && (
                        <View style={styles.surgeonGridPic}>
                          {card.card_details?.surgeonInformation?.picture && (
                            <Image
                              style={styles.surgeonImage}
                              src={card.card_details.surgeonInformation.picture}
                            />
                          )}
                        </View>
                      )}
                    </View>
                    {/* Notes below grid */}
                    {card.card_details?.surgeonInformation?.notes?.length >
                      0 && (
                      <View style={styles.notes}>
                        {card.card_details.surgeonInformation.notes.map(
                          (note: string, index: number) => (
                            <Text key={index} style={styles.notesText}>
                              Note: {note}
                            </Text>
                          )
                        )}
                      </View>
                    )}
                  </View>
                </View>
              )}

              {/* Procedure Information */}
              {(() => {
                const pd = card.card_details?.procedureDetails || {}
                // Check if there's any content to display
                const hasContent =
                  pd.selectedPosition?.other ||
                  pd.selectedPosition?.index !== undefined ||
                  pd.tableRotationSide ||
                  pd.tableRotationDegree ||
                  (pd.skinPrep &&
                    Object.values(pd.skinPrep).some(
                      (value) => value === true
                    )) ||
                  (pd.medication &&
                    (Object.entries(pd.medication).some(([key, details]) => {
                      if (key === 'other') return false
                      if (key === 'selectedMedications')
                        return Array.isArray(details) && details.length > 0
                      const medDetails = details as any
                      return (
                        medDetails.concentration ||
                        medDetails.epiConcentration ||
                        medDetails.volume
                      )
                    }) ||
                      (pd.medication.selectedMedications &&
                        pd.medication.selectedMedications.length > 0))) ||
                  (pd.positioningDevices &&
                    Object.values(pd.positioningDevices).some(
                      (value) => value === true
                    )) ||
                  (pd.notes && pd.notes.length > 0)

                if (!hasContent) return null

                return (
                  <View style={styles.section}>
                    <View style={styles.sectionHeader}>
                      <Text style={styles.sectionTitle}>
                        Procedure Information
                      </Text>
                    </View>
                    <View style={styles.sectionContent}>
                      {(() => {
                        // Prepare content for each mini-section
                        // Position
                        let positionContent = null
                        if (pd.selectedPosition) {
                          const pos = pd.selectedPosition
                          let str = ''
                          if (pos.other && pos.other.trim() !== '') {
                            str = pos.other
                          } else if (
                            typeof pos.index === 'number' &&
                            positions[pos.index]
                          ) {
                            str = positions[pos.index].name
                          }
                          if (pos.side) str += ` (${pos.side})`
                          positionContent = (
                            <View>
                              <Text style={styles.value}>{str}</Text>
                              {typeof pos.index === 'number' &&
                                positions[pos.index] && (
                                  <Image
                                    style={styles.positionImage}
                                    src={positions[pos.index].image}
                                  />
                                )}
                            </View>
                          )
                        }
                        // Table Rotation
                        let tableRotationContent = null
                        if (pd.tableRotationSide) {
                          let str = pd.tableRotationSide
                          if (pd.tableRotationDegree)
                            str += ` - ${pd.tableRotationDegree}°`
                          tableRotationContent = (
                            <Text style={styles.value}>{str}</Text>
                          )
                        }
                        // Skin Preps
                        let skinPrepsContent = null
                        if (
                          pd.skinPrep &&
                          Object.keys(pd.skinPrep).length > 0 &&
                          Object.values(pd.skinPrep).some(
                            (value) => value === true
                          )
                        ) {
                          const skinPrepLabels: { [key: string]: string } = {
                            betadine5: 'Betadine 5%',
                            betadine10: 'Betadine 10%',
                            chlorhexidine: 'Chlorhexidine',
                            chloraPrep: 'Chloraprep',
                            dilutedBetadine: 'Diluted Betadine',
                            PCMX: 'PCMX 3%',
                          }
                          skinPrepsContent = (
                            <View style={styles.checkboxGroup}>
                              {Object.entries(pd.skinPrep).map(
                                ([key, value]) =>
                                  value && (
                                    <View key={key} style={styles.checkboxItem}>
                                      <Text style={styles.checkboxLabel}>
                                        ✓ {skinPrepLabels[key]}
                                      </Text>
                                    </View>
                                  )
                              )}
                            </View>
                          )
                        }
                        // Medication
                        let medicationContent = null
                        if (
                          pd.medication &&
                          Object.entries(pd.medication).some(
                            ([key, details]) => {
                              if (key === 'other') return false
                              if (key === 'selectedMedications')
                                return (
                                  Array.isArray(details) && details.length > 0
                                )
                              const medDetails = details as any
                              return (
                                medDetails.concentration ||
                                medDetails.epiConcentration ||
                                medDetails.volume
                              )
                            }
                          )
                        ) {
                          const medicationLabels: { [key: string]: string } = {
                            lidocaine: 'Lidocaine',
                            lidocaineWithEpi: 'Lidocaine with Epi',
                            marcaine: 'Marcaine',
                            marcaineWithEpi: 'Marcaine with Epi',
                          }
                          medicationContent = (
                            <View>
                              {Object.entries(pd.medication).map(
                                ([medName, medDetails]) => {
                                  if (medName === 'other') return null
                                  if (medName === 'selectedMedications') {
                                    const selectedMeds = medDetails as Array<{
                                      name: string
                                      timing: string
                                    }>
                                    if (
                                      !Array.isArray(selectedMeds) ||
                                      selectedMeds.length === 0
                                    )
                                      return null
                                    return (
                                      <View key={medName}>
                                        {selectedMeds.map((med, index) => (
                                          <View
                                            key={index}
                                            style={{ marginBottom: 4 }}
                                          >
                                            <Text style={styles.value}>
                                              {med.name
                                                .charAt(0)
                                                .toUpperCase() +
                                                med.name
                                                  .slice(1)
                                                  .toLowerCase()}{' '}
                                              ({med.timing})
                                            </Text>
                                          </View>
                                        ))}
                                      </View>
                                    )
                                  }
                                  const details = medDetails as any
                                  if (
                                    !details.concentration &&
                                    !details.epiConcentration &&
                                    !details.volume
                                  )
                                    return null
                                  return (
                                    <View
                                      key={medName}
                                      style={{ marginBottom: 8 }}
                                    >
                                      <Text
                                        style={[
                                          styles.value,
                                          { fontWeight: 'bold' },
                                        ]}
                                      >
                                        {medicationLabels[medName] ||
                                          medName.charAt(0).toUpperCase() +
                                            medName.slice(1).toLowerCase()}
                                        :
                                      </Text>
                                      <Text style={styles.value}>
                                        {details.concentration &&
                                          `Conc: ${details.concentration} `}
                                        {details.epiConcentration &&
                                          `Epi: ${details.epiConcentration} `}
                                        {details.volume &&
                                          `Vol: ${details.volume} cc`}
                                      </Text>
                                    </View>
                                  )
                                }
                              )}
                            </View>
                          )
                        }
                        // Positioning Devices
                        let positioningDevicesContent = null
                        if (
                          pd.positioningDevices &&
                          (Object.keys(pd.positioningDevices).length > 0 ||
                            pd.DVTProhylaxis)
                        ) {
                          const positioningDeviceLabels: {
                            [key: string]: string
                          } = {
                            gelDonut: 'Gel Donut',
                            gelRolls: 'Gel Rolls',
                          }
                          positioningDevicesContent = (
                            <View>
                              {Object.entries(pd.positioningDevices).map(
                                ([key, value]) => {
                                  if (key === 'otherText') return null
                                  if (value) {
                                    if (
                                      key === 'other' &&
                                      pd.positioningDevices.otherText
                                    ) {
                                      return (
                                        <Text key={key} style={styles.value}>
                                          {pd.positioningDevices.otherText}
                                        </Text>
                                      )
                                    } else if (key !== 'other') {
                                      return (
                                        <Text key={key} style={styles.value}>
                                          {positioningDeviceLabels[key]}
                                        </Text>
                                      )
                                    }
                                  }
                                  return null
                                }
                              )}
                              {pd.DVTProhylaxis && (
                                <Text style={styles.value}>
                                  DVT Prophylaxis{' '}
                                  {pd.dvtType ? pd.dvtType : 'Yes'}
                                  {pd.anticoagSide
                                    ? ` - ${pd.anticoagSide}`
                                    : ''}
                                </Text>
                              )}
                            </View>
                          )
                        }
                        // Other Notes
                        let otherNotesContent = null
                        if (pd.notes && pd.notes.length > 0) {
                          otherNotesContent = (
                            <View style={styles.notes}>
                              {pd.notes.map((note: string, index: number) => (
                                <Text key={index} style={styles.notesText}>
                                  Note: {note}
                                </Text>
                              ))}
                            </View>
                          )
                        }
                        // First row: Position, Table Rotation, Positioning Devices, Skin Preps
                        const firstRow = [
                          { title: 'Position', content: positionContent },
                          {
                            title: 'Table Rotation',
                            content: tableRotationContent,
                          },
                          {
                            title: 'Positioning Devices',
                            content: positioningDevicesContent,
                          },
                          {
                            title: 'Skin Preps',
                            content: skinPrepsContent,
                          },
                        ].filter(
                          (col) =>
                            col.content &&
                            // For Positioning Devices, only include if there's actual content or DVT Prophylaxis
                            (col.title !== 'Positioning Devices' ||
                              (col.title === 'Positioning Devices' &&
                                ((pd.positioningDevices &&
                                  Object.values(pd.positioningDevices).some(
                                    (value) => value === true
                                  )) ||
                                  pd.DVTProhylaxis))) &&
                            // For Skin Preps, only include if there's actual content
                            (col.title !== 'Skin Preps' ||
                              (col.title === 'Skin Preps' &&
                                pd.skinPrep &&
                                Object.values(pd.skinPrep).some(
                                  (value) => value === true
                                )))
                        )

                        // Second row: Medication
                        const secondRow = [
                          { title: 'Medication', content: medicationContent },
                        ].filter(
                          (col) =>
                            col.content &&
                            // For Medication, only include if there's actual content
                            (col.title !== 'Medication' ||
                              (col.title === 'Medication' &&
                                pd.medication &&
                                Object.entries(pd.medication).some(
                                  ([key, details]) => {
                                    if (key === 'other') return false
                                    if (key === 'selectedMedications')
                                      return (
                                        Array.isArray(details) &&
                                        details.length > 0
                                      )
                                    const medDetails = details as any
                                    return (
                                      medDetails.concentration ||
                                      medDetails.epiConcentration ||
                                      medDetails.volume
                                    )
                                  }
                                )))
                        )

                        return (
                          <View>
                            {/* First row */}
                            <View
                              style={{ flexDirection: 'row', marginBottom: 2 }}
                            >
                              {firstRow.map((col, idx) => (
                                <View
                                  key={col.title}
                                  style={{ flex: 1, marginRight: 4 }}
                                >
                                  <Text
                                    style={[
                                      styles.subsectionTitle,
                                      { fontSize: 11 },
                                    ]}
                                  >
                                    {col.title}
                                  </Text>
                                  {col.content}
                                </View>
                              ))}
                              {/* Fill empty columns for alignment */}
                              {Array.from({ length: 4 - firstRow.length }).map(
                                (_, i) => (
                                  <View
                                    key={`empty1-${i}`}
                                    style={{ flex: 1, marginRight: 4 }}
                                  />
                                )
                              )}
                            </View>
                            {/* Second row */}
                            <View
                              style={{ flexDirection: 'row', marginBottom: 4 }}
                            >
                              {secondRow.map((col, idx) => (
                                <View
                                  key={col.title}
                                  style={{
                                    flex: 1,
                                    marginRight: 4,
                                    minWidth: '100%',
                                    maxWidth: '100%',
                                    alignItems: 'flex-start',
                                  }}
                                >
                                  <Text
                                    style={[
                                      styles.subsectionTitle,
                                      { fontSize: 11 },
                                    ]}
                                  >
                                    {col.title}
                                  </Text>
                                  {col.content}
                                </View>
                              ))}
                            </View>
                            {/* Procedure Notes (if any) */}
                            {otherNotesContent}
                          </View>
                        )
                      })()}
                    </View>
                  </View>
                )
              })()}

              {/* Equipment Information */}
              {card.card_details?.equipment?.options?.[0] &&
                Object.keys(card.card_details.equipment.options[0]).length >
                  0 && (
                  <View style={styles.section} wrap={false}>
                    <View style={styles.sectionHeader}>
                      <Text style={styles.sectionTitle}>
                        Equipment Information
                      </Text>
                    </View>
                    <View style={styles.sectionContent}>
                      {/* Devices with settings: 2-per-line, side-by-side layout */}
                      <Text
                        style={[
                          {
                            fontSize: 12,
                            marginBottom: 12,
                            color: 'rgb(51, 51, 51)',
                          },
                        ]}
                      >
                        Equipment with Settings
                      </Text>
                      {(() => {
                        const equipment =
                          card.card_details.equipment.options[0] || {}
                        const devicesWithSettings = [
                          'Monopolar',
                          'Bipolar',
                          'Robot',
                          'Drill',
                          'Sonopet',
                          'CUSA',
                          'Laser',
                          'Cell Saver',
                        ]
                        // Collect settings for each device
                        const deviceSettings: Record<string, [string, any][]> =
                          {}
                        Object.entries(equipment).forEach(([key, value]) => {
                          const match = key.match(/^([A-Za-z ]+?)\(([^)]+)\)$/)
                          if (match) {
                            const setting = match[1]
                            const device = match[2]
                            if (!deviceSettings[device])
                              deviceSettings[device] = []
                            deviceSettings[device].push([setting, value])
                          }
                        })
                        // Add special settings to deviceSettings
                        Object.entries(specialSettingsMap).forEach(
                          ([key, { parent, label }]) => {
                            if (equipment[key]) {
                              if (!deviceSettings[parent])
                                deviceSettings[parent] = []
                              deviceSettings[parent].push([
                                label,
                                equipment[key],
                              ])
                            }
                          }
                        )
                        // Prepare device/settings lines
                        const deviceLines = devicesWithSettings
                          .filter((device) => equipment[device])
                          .map((device) => {
                            const settings = deviceSettings[device] || []
                            const validSettings = settings.filter(
                              ([_, val]) =>
                                val !== undefined && val !== null && val !== ''
                            )
                            const settingsString =
                              validSettings.length > 0
                                ? ' ' +
                                  validSettings
                                    .map(
                                      ([setting, val]) => `${setting}: ${val}`
                                    )
                                    .join(' ')
                                : ''
                            return (
                              <Text
                                key={device}
                                style={{
                                  fontSize: 10,
                                  marginBottom: 2,
                                  color: 'rgb(51, 51, 51)',
                                }}
                              >
                                {device}
                                {validSettings.length > 0 ? ' :' : ''}
                                {settingsString}
                              </Text>
                            )
                          })
                        // Group into pairs
                        const rows = []
                        for (let i = 0; i < deviceLines.length; i += 2) {
                          rows.push([
                            deviceLines[i],
                            deviceLines[i + 1] || (
                              <Text
                                key={'empty-' + i}
                                style={{ fontSize: 11, marginBottom: 2 }}
                              />
                            ),
                          ])
                        }
                        // Render each row as a flex row with 2 columns
                        return rows.map((pair, idx) => (
                          <View
                            key={idx}
                            style={{
                              flexDirection: 'row',
                              width: '100%',
                              marginBottom: 2,
                            }}
                          >
                            <View style={{ width: '50%' }}>{pair[0]}</View>
                            <View style={{ width: '50%' }}>{pair[1]}</View>
                          </View>
                        ))
                      })()}
                      <Text
                        style={[
                          {
                            fontSize: 12,
                            marginVertical: 12,
                            color: 'rgb(51, 51, 51)',
                          },
                        ]}
                      >
                        Equipments
                      </Text>
                      {/* Other devices: 4-column grid */}
                      <View style={styles.equipmentGrid}>
                        {(() => {
                          const equipment =
                            card.card_details.equipment.options[0] || {}
                          const devicesWithSettings = [
                            'Monopolar',
                            'Bipolar',
                            'Robot',
                            'Drill',
                            'Sonopet',
                            'CUSA',
                            'Laser',
                            'Cell Saver',
                          ]
                          const rendered: JSX.Element[] = []
                          // Render all other devices (no settings)
                          Object.entries(equipment).forEach(([key, value]) => {
                            if (
                              !devicesWithSettings.includes(key) &&
                              typeof value === 'boolean' &&
                              value
                            ) {
                              rendered.push(
                                <Text key={key} style={styles.equipmentItem}>
                                  {key}
                                </Text>
                              )
                            }
                          })
                          // Render other string/number values (not settings), but skip settings for devicesWithSettings and special settings
                          Object.entries(equipment).forEach(([key, value]) => {
                            if (
                              !key.match(/^([A-Za-z ]+)\(([^)]+)\)$/) &&
                              !devicesWithSettings.includes(key) &&
                              !Object.keys(specialSettingsMap).includes(key) &&
                              ((typeof value === 'string' &&
                                value.trim() !== '') ||
                                typeof value === 'number')
                            ) {
                              const formattedKey = key
                                .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
                                .replace(/([a-z])([A-Z])/g, '$1 $2')
                                .replace(/^./, (str) => str.toUpperCase())
                                .replace(/\s+/g, ' ')
                                .replace(/\s*\/\s*/g, '/')
                                .replace(/([a-zA-Z])\(/g, '$1 (')
                                .replace(/\s*\)\s*/g, ') ')
                                .replace(/\s*-\s*/g, '-')
                                .replace(/\s*:\s*/g, ': ')
                                .trim()
                              rendered.push(
                                <Text key={key} style={styles.equipmentItem}>
                                  {formattedKey}: {value}
                                </Text>
                              )
                            }
                          })
                          return rendered
                        })()}
                      </View>
                      {/* Equipment Notes */}
                      {card.card_details.equipment.notes?.length > 0 && (
                        <View style={styles.notes}>
                          {card.card_details.equipment.notes.map(
                            (note: string, index: number) => (
                              <Text key={index} style={styles.notesText}>
                                Note: {note}
                              </Text>
                            )
                          )}
                        </View>
                      )}
                    </View>
                  </View>
                )}

              {/* Instrument Trays */}
              {card.card_details?.instrumentTrays?.instruments?.length > 0 && (
                <View style={styles.section}>
                  <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Instrument Trays</Text>
                  </View>
                  <View style={styles.sectionContent}>
                    <View style={styles.equipmentGrid}>
                      {card.card_details.instrumentTrays.instruments.map(
                        (tray: string) => (
                          <Text key={tray} style={styles.equipmentItem}>
                            {tray}
                          </Text>
                        )
                      )}
                    </View>
                    {/* Instrument Trays Notes */}
                    {card.card_details.instrumentTrays.notes?.length > 0 && (
                      <View style={styles.notes}>
                        {card.card_details.instrumentTrays.notes.map(
                          (note: string, index: number) => (
                            <Text key={index} style={styles.notesText}>
                              Note: {note}
                            </Text>
                          )
                        )}
                      </View>
                    )}
                  </View>
                </View>
              )}

              {/* Implants Section */}
              {showPascPreferenceCardFeatures
                ? card.card_details?.products?.implants?.length > 0 && (
                    <View style={styles.section}>
                      <View style={styles.sectionHeader}>
                        <Text style={styles.sectionTitle}>Implants</Text>
                      </View>
                      <View style={styles.sectionContent}>
                        <View
                          style={[
                            styles.grid3ColContainer,
                            { justifyContent: 'flex-start' },
                          ]}
                        >
                          {card.card_details.products.implants.map(
                            (implant: any, index: number) => (
                              <Text
                                key={index}
                                style={[
                                  styles.grid3ColItem,
                                  (index + 1) % 2 !== 0
                                    ? { marginRight: 3 }
                                    : {},
                                ]}
                              >
                                {implant.description}
                              </Text>
                            )
                          )}
                          {/* Add empty elements to ensure left alignment */}
                          {card.card_details.products.implants.length % 2 !==
                            0 && (
                            <View
                              style={[
                                styles.grid3ColItem,
                                { backgroundColor: 'transparent' },
                              ]}
                            />
                          )}
                        </View>
                      </View>
                    </View>
                  )
                : card.card_details?.companies?.implants?.length > 0 && (
                    <View style={styles.section}>
                      <View style={styles.sectionHeader}>
                        <Text style={styles.sectionTitle}>Implants</Text>
                      </View>
                      <View style={styles.sectionContent}>
                        <View
                          style={[
                            styles.grid3ColContainer,
                            { justifyContent: 'flex-start' },
                          ]}
                        >
                          {card.card_details.companies.implants.map(
                            (company: any, index: number) => (
                              <Text
                                key={index}
                                style={[
                                  styles.grid3ColItem,
                                  (index + 1) % 2 !== 0
                                    ? { marginRight: 3 }
                                    : {},
                                ]}
                              >
                                {company.name}
                              </Text>
                            )
                          )}
                          {/* Add empty elements to ensure left alignment */}
                          {card.card_details.companies.implants.length % 2 !==
                            0 && (
                            <View
                              style={[
                                styles.grid3ColItem,
                                { backgroundColor: 'transparent' },
                              ]}
                            />
                          )}
                        </View>
                      </View>
                    </View>
                  )}

              {/* Biologics Section */}
              {showPascPreferenceCardFeatures
                ? card.card_details?.products?.biologic?.length > 0 && (
                    <View style={styles.section}>
                      <View style={styles.sectionHeader}>
                        <Text style={styles.sectionTitle}>Biologics</Text>
                      </View>
                      <View style={styles.sectionContent}>
                        <View
                          style={[
                            styles.grid3ColContainer,
                            { justifyContent: 'flex-start' },
                          ]}
                        >
                          {card.card_details.products.biologic.map(
                            (biologic: any, index: number) => (
                              <Text
                                key={index}
                                style={[
                                  styles.grid3ColItem,
                                  (index + 1) % 2 !== 0
                                    ? { marginRight: 3 }
                                    : {},
                                ]}
                              >
                                {biologic.description}
                              </Text>
                            )
                          )}
                          {/* Add empty elements to ensure left alignment */}
                          {card.card_details.products.biologic.length % 2 !==
                            0 && (
                            <View
                              style={[
                                styles.grid3ColItem,
                                { backgroundColor: 'transparent' },
                              ]}
                            />
                          )}
                        </View>
                      </View>
                    </View>
                  )
                : card.card_details?.companies?.biologic?.length > 0 && (
                    <View style={styles.section}>
                      <View style={styles.sectionHeader}>
                        <Text style={styles.sectionTitle}>Biologics</Text>
                      </View>
                      <View style={styles.sectionContent}>
                        <View
                          style={[
                            styles.grid3ColContainer,
                            { justifyContent: 'flex-start' },
                          ]}
                        >
                          {card.card_details.companies.biologic.map(
                            (company: any, index: number) => (
                              <Text
                                key={index}
                                style={[
                                  styles.grid3ColItem,
                                  (index + 1) % 2 !== 0
                                    ? { marginRight: 3 }
                                    : {},
                                ]}
                              >
                                {company.name}
                              </Text>
                            )
                          )}
                          {/* Add empty elements to ensure left alignment */}
                          {card.card_details.companies.biologic.length % 2 !==
                            0 && (
                            <View
                              style={[
                                styles.grid3ColItem,
                                { backgroundColor: 'transparent' },
                              ]}
                            />
                          )}
                        </View>
                      </View>
                    </View>
                  )}

              {/* Sales Representatives Section */}
              {!showPascPreferenceCardFeatures &&
                card.card_details?.linkedSalesReps?.length > 0 && (
                  <View style={styles.section}>
                    <View style={styles.sectionHeader}>
                      <Text style={styles.sectionTitle}>
                        Sales Representatives
                      </Text>
                    </View>
                    <View style={styles.sectionContent}>
                      {/* Regular Sales Reps */}
                      {Object.entries(
                        card.card_details.linkedSalesReps
                          .filter((rep: any) => !rep.isSpecialtyRep)
                          .reduce((acc: any, rep: any) => {
                            // Find the company name from the selected companies
                            const company =
                              card.card_details.companies?.implants?.find(
                                (c: any) => c.id === rep.companyId
                              ) ||
                              card.card_details.companies?.biologic?.find(
                                (c: any) => c.id === rep.companyId
                              )
                            const companyName =
                              company?.name || rep.companyName || 'Other'
                            if (!acc[companyName]) {
                              acc[companyName] = []
                            }
                            acc[companyName].push(rep)
                            return acc
                          }, {})
                      ).map(([companyName, reps]: [string, any]) => (
                        <View
                          key={companyName}
                          style={{ marginBottom: 2, width: '100%' }}
                        >
                          <Text
                            style={[
                              styles.subsectionTitle,
                              {
                                color: 'rgb(80, 53, 237)',
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                width: '100%',
                                marginBottom: 2,
                              },
                            ]}
                          >
                            {companyName}
                          </Text>
                          {/* Grid: chunk reps into pairs */}
                          {Array.from({
                            length: Math.ceil(reps.length / 2),
                          }).map((_, rowIdx) => (
                            <View
                              key={rowIdx}
                              style={{
                                flexDirection: 'row',
                                width: '100%',
                                marginBottom: 4,
                                gap: 4,
                              }}
                            >
                              {reps
                                .slice(rowIdx * 2, rowIdx * 2 + 2)
                                .map((rep: any, colIdx: number) => (
                                  <View
                                    key={colIdx}
                                    style={{
                                      flex: 1,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 2,
                                      backgroundColor: 'rgb(223, 217, 252)',
                                      borderRadius: 5,
                                      minWidth: 0,
                                    }}
                                  >
                                    <View
                                      style={{
                                        flex: 1,
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        width: '100%',
                                        paddingLeft: 8,
                                        paddingTop: 4,
                                        paddingBottom: 4,
                                      }}
                                    >
                                      <Text
                                        style={[
                                          styles.value,
                                          {
                                            fontWeight: 'bold',
                                            fontSize: 11,
                                            width: '100%',
                                            lineHeight: 1.1,
                                          },
                                        ]}
                                      >
                                        {rep.name}
                                      </Text>
                                      <Text
                                        style={[
                                          styles.value,
                                          {
                                            fontSize: 9,
                                            color: 'rgb(102, 102, 102)',
                                            width: '100%',
                                            lineHeight: 1.1,
                                          },
                                        ]}
                                      >
                                        {rep.email}
                                      </Text>
                                      {rep.phoneNumber && (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 9,
                                              color: 'rgb(102, 102, 102)',
                                              width: '100%',
                                              lineHeight: 1.1,
                                            },
                                          ]}
                                        >
                                          {rep.phoneNumber}
                                        </Text>
                                      )}
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginLeft: 2,
                                        minWidth: 50,
                                        maxWidth: 50,
                                        flexShrink: 0,
                                      }}
                                    >
                                      {rep.sendSms && rep.sendEmail ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          SMS & Email
                                        </Text>
                                      ) : rep.sendSms ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          SMS
                                        </Text>
                                      ) : rep.sendEmail ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          Email
                                        </Text>
                                      ) : null}
                                    </View>
                                  </View>
                                ))}
                              {/* Fill empty space if needed */}
                              {reps.slice(rowIdx * 2, rowIdx * 2 + 2).length ===
                                1 && <View style={{ flex: 1 }} />}
                            </View>
                          ))}
                        </View>
                      ))}

                      {/* Specialty Representatives Section */}
                      {card.card_details.linkedSalesReps.filter(
                        (rep: any) => rep.isSpecialtyRep
                      ).length > 0 && (
                        <View>
                          <Text
                            style={[
                              styles.subsectionTitle,
                              { color: 'rgb(80, 53, 237)' },
                            ]}
                          >
                            Specialty Representatives
                          </Text>
                          <View
                            style={{
                              flexDirection: 'row',
                              width: '100%',
                              gap: 4,
                            }}
                          >
                            {Object.entries(
                              card.card_details.linkedSalesReps
                                .filter((rep: any) => rep.isSpecialtyRep)
                                .reduce((acc: any, rep: any) => {
                                  const specialty = rep.specialty || 'Other'
                                  if (!acc[specialty]) {
                                    acc[specialty] = []
                                  }
                                  acc[specialty].push(rep)
                                  return acc
                                }, {})
                            ).map(([specialty, reps]: [string, any]) => {
                              const rep = reps[0] // Only show one per specialty
                              return (
                                <View key={specialty} style={{ flex: 1 }}>
                                  <Text
                                    style={[
                                      styles.value,
                                      {
                                        fontWeight: 'bold',
                                        fontSize: 11,
                                        color: 'rgb(80, 53, 237)',
                                        marginBottom: 2,
                                      },
                                    ]}
                                  >
                                    {specialty}
                                  </Text>
                                  <View
                                    style={{
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 2,
                                      backgroundColor: 'rgb(223, 217, 252)',
                                      borderRadius: 5,
                                      minWidth: 0,
                                    }}
                                  >
                                    <View
                                      style={{
                                        flex: 1,
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        width: '100%',
                                        paddingLeft: 8,
                                        paddingTop: 4,
                                        paddingBottom: 4,
                                      }}
                                    >
                                      <Text
                                        style={[
                                          styles.value,
                                          {
                                            fontWeight: 'bold',
                                            fontSize: 11,
                                            width: '100%',
                                            lineHeight: 1.1,
                                          },
                                        ]}
                                      >
                                        {rep.name}
                                      </Text>
                                      <Text
                                        style={[
                                          styles.value,
                                          {
                                            fontSize: 9,
                                            color: 'rgb(102, 102, 102)',
                                            width: '100%',
                                            lineHeight: 1.1,
                                          },
                                        ]}
                                      >
                                        {rep.email}
                                      </Text>
                                      {rep.phoneNumber && (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 9,
                                              color: 'rgb(102, 102, 102)',
                                              width: '100%',
                                              lineHeight: 1.1,
                                            },
                                          ]}
                                        >
                                          {rep.phoneNumber}
                                        </Text>
                                      )}
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginLeft: 2,
                                        minWidth: 50,
                                        maxWidth: 50,
                                        flexShrink: 0,
                                      }}
                                    >
                                      {rep.sendSms && rep.sendEmail ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          SMS & Email
                                        </Text>
                                      ) : rep.sendSms ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          SMS
                                        </Text>
                                      ) : rep.sendEmail ? (
                                        <Text
                                          style={[
                                            styles.value,
                                            {
                                              fontSize: 6.5,
                                              color: 'rgb(80, 53, 237)',
                                              textAlign: 'center',
                                              width: '100%',
                                            },
                                          ]}
                                        >
                                          Email
                                        </Text>
                                      ) : null}
                                    </View>
                                  </View>
                                </View>
                              )
                            })}
                          </View>
                        </View>
                      )}
                    </View>
                  </View>
                )}

              {/* Consumables */}
              {card.card_details?.consumables?.items?.length > 0 && (
                <View style={styles.section}>
                  <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Consumables</Text>
                  </View>
                  <View style={styles.sectionContent}>
                    <View style={styles.table}>
                      {/* Table Header */}
                      <View style={[styles.tableRow, styles.headerRow]}>
                        <Text
                          style={[
                            styles.tableCell,
                            styles.tableCellDescription,
                            {
                              width: '60%',
                              minWidth: 120,
                              maxWidth: 350,
                              fontSize: 10,
                              textAlign: 'left',
                              flexWrap: 'wrap',
                              lineHeight: 1.2,
                            },
                          ]}
                        >
                          Description
                        </Text>
                        <Text
                          style={[
                            styles.tableCell,
                            {
                              width: '25%',
                              minWidth: 60,
                              maxWidth: 160,
                              fontSize: 10,
                              textAlign: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                          ]}
                        >
                          Tags
                        </Text>
                        <Text
                          style={[
                            styles.tableCell,
                            styles.tableCellQuantity,
                            {
                              width: '15%',
                              minWidth: 28,
                              maxWidth: 60,
                              textAlign: 'center',
                            },
                          ]}
                        >
                          Qty
                        </Text>
                      </View>
                      {/* Table Rows */}
                      {[...(card.card_details.consumables.items || [])]
                        .sort((a: any, b: any) => {
                          const aHasTags =
                            Array.isArray(a.tags) && a.tags.length > 0
                          const bHasTags =
                            Array.isArray(b.tags) && b.tags.length > 0
                          if (aHasTags && bHasTags) {
                            return a.tags[0].localeCompare(b.tags[0])
                          }
                          if (aHasTags) return -1
                          if (bHasTags) return 1
                          return 0
                        })
                        .map((item: any, idx: number) => {
                          const product = products.find(
                            (p) => p.id === item.bidProductId
                          )
                          const description =
                            product?.deviceDescription ||
                            `Product ID: ${item.bidProductId}`
                          let quantity =
                            item.measurement?.type === 'fraction'
                              ? `${item.measurement.numerator}/${item.measurement.denominator}`
                              : item.qty
                          if (
                            quantity === undefined ||
                            quantity === null ||
                            quantity === ''
                          )
                            quantity = 0
                          const tags =
                            Array.isArray(item.tags) && item.tags.length > 0
                              ? item.tags.join(', ')
                              : '-'
                          return (
                            <View
                              key={idx}
                              style={[
                                styles.tableRow,
                                idx % 2 === 0 ? styles.rowEven : styles.rowOdd,
                              ]}
                            >
                              <Text
                                style={[
                                  styles.tableCell,
                                  styles.tableCellDescription,
                                  {
                                    width: '60%',
                                    minWidth: 120,
                                    maxWidth: 350,
                                    fontSize: 10,
                                    textAlign: 'left',
                                    flexWrap: 'wrap',
                                    lineHeight: 1.2,
                                  },
                                ]}
                              >
                                {description}
                              </Text>
                              <Text
                                style={[
                                  styles.tableCell,
                                  {
                                    width: '25%',
                                    minWidth: 60,
                                    maxWidth: 160,
                                    fontSize: 10,
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  },
                                ]}
                              >
                                {tags}
                              </Text>
                              <Text
                                style={[
                                  styles.tableCell,
                                  styles.tableCellQuantity,
                                  {
                                    width: '15%',
                                    minWidth: 28,
                                    maxWidth: 60,
                                    textAlign: 'center',
                                  },
                                ]}
                              >
                                {quantity}
                              </Text>
                            </View>
                          )
                        })}
                    </View>
                  </View>
                </View>
              )}
            </>
          )}
          <Footer />
        </Page>
      ))}
    </Document>
  )
}

export default PreferenceCardsPDF
